module.exports = __webpack_public_path__ + "static/media/YM54_5.7cfcc7c7.jpg";